export default __webpack_public_path__ + "static/media/service-Sales-Marketing.6d5168fe.jpg";